import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';
import ContactForm from '@/pages/about/components/ContactForm';

export default function AboutPage() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于色漫屋 - 品牌介绍与联系方式',
    description: '色漫屋品牌介绍、口碑声誉与联系方式。色漫屋是专为漫画爱好者打造的在线漫画平台，汇聚海量漫画资源，涵盖多种题材与风格。',
    url: 'https://baixinsh.com.cn/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '色漫屋',
      url: 'https://baixinsh.com.cn',
    },
    about: {
      '@type': 'Organization',
      name: '色漫屋',
      description: '色漫屋是专为漫画爱好者打造的在线漫画平台，汇聚海量漫画资源，涵盖多种题材与风格，支持免费在线阅读与下载。',
      foundingDate: '2024',
      url: 'https://baixinsh.com.cn',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'contact@semanwu.com',
        availableLanguage: ['Chinese'],
      },
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '色漫屋是什么网站？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '色漫屋是专为漫画爱好者打造的在线漫画平台，汇聚海量漫画资源，涵盖热血、恋爱、悬疑、搞笑等多种题材与风格，支持免费在线阅读与下载，更新快速，分类清晰。',
        },
      },
      {
        '@type': 'Question',
        name: '色漫屋的漫画资源是否免费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，色漫屋所有漫画资源均支持免费在线阅读。我们致力于为广大漫画爱好者提供优质的阅读体验，无需付费即可畅享海量漫画内容。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系色漫屋团队？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过以下方式联系色漫屋团队：发送邮件至 contact@semanwu.com，关注我们的官方微博或B站账号，或使用网站上的联系表单提交您的反馈和问题。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于色漫屋 - 品牌介绍与联系方式 | 海量漫画一站畅读"
        description="色漫屋品牌介绍、口碑声誉与联系方式。色漫屋是专为漫画爱好者打造的在线漫画平台，汇聚海量漫画资源，涵盖多种题材与风格，支持免费在线阅读与下载。"
        keywords="色漫屋关于,色漫屋品牌介绍,色漫屋联系方式,色漫屋口碑"
        canonicalUrl="https://baixinsh.com.cn/about"
        ogTitle="关于色漫屋 - 品牌介绍与联系方式"
        ogDescription="色漫屋品牌介绍、口碑声誉与联系方式。色漫屋是专为漫画爱好者打造的在线漫画平台。"
        structuredData={{ ...aboutSchema, ...faqSchema, '@context': 'https://schema.org' }}
      />

      <article>
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-8">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mt-8 text-center max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-heading text-foreground-900">
              关于色漫屋
            </h1>
            <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
              海量漫画资源一站畅读，用心为每一位漫画爱好者打造的在线漫画家园
            </p>
          </section>

          <section className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-8 rounded-xl bg-background-100">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-book-read-line text-2xl md:text-3xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mt-4">海量资源</h3>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                涵盖热血、恋爱、悬疑、搞笑、奇幻、科幻等十余种题材，数千部漫画作品持续更新中
              </p>
            </div>
            <div className="text-center p-8 rounded-xl bg-background-100">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-flashlight-line text-2xl md:text-3xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mt-4">更新快速</h3>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                与各大漫画平台同步更新，第一时间为您呈现最新章节，追漫不再等待
              </p>
            </div>
            <div className="text-center p-8 rounded-xl bg-background-100">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                <i className="ri-shield-check-line text-2xl md:text-3xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mt-4">免费畅读</h3>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                所有漫画资源免费阅读，无需付费，让每一位漫画爱好者都能尽情享受阅读乐趣
              </p>
            </div>
          </section>

          <section className="mt-20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
                  品牌故事
                </h2>
                <div className="mt-6 space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  <p>
                    色漫屋诞生于2024年，由一群热爱漫画的年轻人创立。我们深知每一位漫画爱好者在追漫过程中的期待与喜悦，因此立志打造一个让所有人都能轻松畅享漫画乐趣的平台。
                  </p>
                  <p>
                    从最初几十部漫画作品起步，到如今汇聚海量漫画资源，色漫屋始终秉持<strong>「让好漫画触手可及」</strong>的理念，不断优化阅读体验，扩展内容库，为超过百万漫画爱好者提供优质的在线阅读服务。
                  </p>
                  <p>
                    我们不仅关注内容的丰富性，更注重分类的清晰度和更新的及时性。无论是热血少年的成长故事，还是甜蜜动人的恋爱物语，亦或是扣人心弦的悬疑推理，在色漫屋，你总能找到属于自己的那本漫画。
                  </p>
                </div>
              </div>
              <div className="rounded-xl overflow-hidden bg-background-200 h-72 md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cozy%20modern%20creative%20workspace%20with%20manga%20bookshelves%2C%20warm%20orange%20and%20coral%20accent%20lighting%2C%20comic%20art%20on%20walls%2C%20comfortable%20reading%20nook%2C%20anime%20merchandise%2C%20clean%20minimalist%20design%2C%20inviting%20atmosphere%2C%20editorial%20photography%20style&width=800&height=500&seq=about-brand-story&orientation=landscape"
                  alt="色漫屋品牌故事 - 温馨的漫画阅读空间"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </section>

          <section className="mt-20">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center">
              用户口碑
            </h2>
            <p className="text-sm text-foreground-600 text-center mt-3">
              来自漫画爱好者们的真实评价
            </p>
            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                {
                  name: '追漫小王子',
                  rating: 5,
                  text: '色漫屋的资源真的太丰富了！之前找了好久的冷门漫画居然这里都有，而且更新速度和正版平台同步，追漫体验一级棒！',
                  date: '2026-07-28',
                },
                {
                  name: '樱花雨',
                  rating: 5,
                  text: '作为恋爱漫画的忠实粉丝，色漫屋的恋爱专区简直是我的快乐源泉。分类清晰，推荐精准，每天都在期待更新！',
                  date: '2026-08-02',
                },
                {
                  name: '剑心依旧',
                  rating: 4,
                  text: '热血漫画的收录非常全面，画质清晰，翻页流畅。唯一的小遗憾是希望增加更多的完结作品推荐，方便一口气看完。',
                  date: '2026-08-05',
                },
              ].map((review, index) => (
                <div key={index} className="p-6 rounded-xl bg-background-100">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-sm w-4 h-4 flex items-center justify-center ${i < review.rating ? 'text-accent-500' : 'text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{review.text}</p>
                  <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/70">
                    <span className="text-sm font-medium text-foreground-900">{review.name}</span>
                    <span className="text-xs text-foreground-500">{review.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mt-20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-600 mt-4 leading-relaxed">
                  如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们。我们会在24小时内回复您的消息。
                </p>
                <div className="mt-8 space-y-4">
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">电子邮箱</p>
                      <a href="mailto:contact@semanwu.com" className="text-sm font-medium text-foreground-900 hover:text-primary-500 transition-colors cursor-pointer">
                        contact@semanwu.com
                      </a>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                      <i className="ri-weibo-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">官方微博</p>
                      <a href="https://weibo.com/semanwu" target="_blank" rel="nofollow noopener noreferrer" className="text-sm font-medium text-foreground-900 hover:text-primary-500 transition-colors cursor-pointer">
                        @色漫屋官方
                      </a>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                      <i className="ri-bilibili-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">B站官方号</p>
                      <a href="https://space.bilibili.com/semanwu" target="_blank" rel="nofollow noopener noreferrer" className="text-sm font-medium text-foreground-900 hover:text-primary-500 transition-colors cursor-pointer">
                        色漫屋
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <ContactForm />
              </div>
            </div>
          </section>
        </div>
      </article>
    </>
  );
}